import { memo } from 'react';

export const CircleLock = memo(({ isGameClosed, isRotate }) => {
  return (
    <div className='pascal-game-col-circle'>
      <div className={`game-circle-bottom-img-block ${!isGameClosed && !isRotate ? 'lock' : ' '} `}>
        <div className='game-circle-shadow-wrp'>
          <div className='game-circle-shadow-ins' />
        </div>
        <div className='close-circle-shadow' />
      </div>
    </div>
  );
});
